module.exports = __webpack_public_path__ + "img/Communities.0351ecff.png";